import React, { useEffect, useState } from 'react'
import { Header, Footer, Infobox } from "../Components"
import { Link, useNavigate } from 'react-router-dom'
import { Api, Images } from '../Constants'
import Select from 'react-select'
import ReCAPTCHA from "react-google-recaptcha"
import { useForm } from "react-hook-form";
import moment from 'moment';
import { toast } from 'react-toastify';
import { MdDelete } from "react-icons/md"
import { FaHome, FaTrash } from 'react-icons/fa'

const Book = () => {
    const [showClose, setShowClose] = useState(false);
    const [step, setStep] = useState(1)
    // const [country, setCountry] = useState()
    const [show, setShow] = useState(false)
    const [notice, setNotice] = useState()
    const [deleteIndex, setDeleteIndex] = useState(null)
    const [isPageLoading, setIsPageLoading] = React.useState(true);
    const [showModal, setShowModal] = useState(false)
    const [removeModal, setRemoveModal] = useState(false)
    const [qtyError, setqtyError] = useState(false)
    const [tickets, setTickets] = useState([])
    const [selectedTicket, setselectedTicket] = useState(null)
    const [selectedTicketID, setselectedTicketID] = useState()
    const [tableData, settableData] = useState([])
    const [paymentMethod, setpaymentMethod] = useState([])
    const [quantity, setQuantity] = useState(1)
    const [footData, setfootData] = useState({ subTotal: null, discount: null, taxable: null, vat: null, total: null })
    const [captcha, setCaptcha] = useState(false);
    const [choseTicket, setChoseTicket] = useState(false);
    const [clickedID, setclickedID] = useState(null)
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm()
    const [isLoading, setIsLoading] = React.useState(false);
    let navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0)

        const getData = async () => {
            const ipres = await Api.getIPAddress();
            const res = await Api.getTickets()
            const payres = await Api.getPaymentMethod()
            const siteRes = await Api.getSiteSetting()
            if (siteRes.status) {
                setShow(siteRes.data.show_ticket)
                setNotice(siteRes.data.notice)
            }
            let country;
            if (ipres?.status == 200) {
                country = ipres.data.country_name
            } else {
                country = 'default'
            }
            console.log('country', country)
            if (res.status) {
                const Tickets = res.data.customer_type.map((elem) => {
                    let dplabel = parseFloat(elem.rate) - parseFloat(elem.discount_amount)
                    dplabel = dplabel.toFixed(2)
                    // dplabel = elem.name + ' ( NPR ' +dplabel+ ' )'
                    dplabel = elem.name 
                return {
                    ...elem,
                    value: elem.id,
                    label: dplabel,
                }
                })
                const NepaliTickets = Tickets.filter(elem => elem.nationality_type === 'Nepali')
                const OtherTickets = Tickets.filter(elem => elem.nationality_type !== 'Nepali')
                let defaultTicket
                if (country == 'Nepal') {
                    setTickets(NepaliTickets)
                    defaultTicket = NepaliTickets[0]

                } else if (country == 'default') {
                    setTickets(Tickets)
                    defaultTicket = Tickets[0]
                } else {
                    setTickets(OtherTickets)
                    defaultTicket = OtherTickets[0]
                }
                setselectedTicket(defaultTicket)
                setselectedTicketID(defaultTicket.value)
                updatePriceData(quantity, defaultTicket.rate, defaultTicket.discount_amount)
                if (siteRes.status) {
                    if(siteRes.data.show_ticket == true) {
                        setShowModal(true)
                    }
                    else if(siteRes.data.show_ticket == false) {
                        setShowModal(false)
                    }
                    else {
                        setShowModal(true)
                    }
                }
            }
            if(payres.status){
                let resdata = payres.data.data
                let newdata = resdata.map(elem => {
                    let imgUrl
                    switch(elem.name.toLowerCase()){
                        case 'fonepay':
                            imgUrl = Images.fonepay
                            break;
                        case 'esewa':
                            imgUrl = Images.esewa
                            break;
                        case 'khalti':
                            imgUrl = Images.khalti
                            break;
                        default:
                            imgUrl = Images.rupee
                    }
                    return {
                        ...elem,
                        imgUrl: imgUrl,
                    }
                })
                setpaymentMethod(newdata)
                setIsPageLoading(false)
            }else {
                if (!toast.isActive('1')) {
                    toast.error('Failed to load payment option data.');
                }
                setIsPageLoading(false)
            }
        }
        getData()

        return () => {};
    }, []);

    const onChangeTicket = ticket_id => {
        let selectedTicket = tickets.filter(elem => elem.id === ticket_id)
        selectedTicket = selectedTicket[0]
        setselectedTicket(selectedTicket)
        updatePriceData(quantity, selectedTicket.rate, selectedTicket.discount_amount)
    }

    // const onChangeQantity = qty => {
    //     if(qty < 1) {
    //         setqtyError(true)
    //     }else {
    //         setqtyError(false)
    //         setQuantity(qty)
    //         updatePriceData(qty, selectedTicket.rate, selectedTicket.discount_amount)
    //     }
    // }
    const onChangeQuantity = (qty) => {
        // console.log(qty)
        // Allow empty value to enable deletion/backspace
        if (qty === '' || qty === undefined) {
            setQuantity(qty);
            return;
        }
    
        // Convert qty to a number for further validation
        const numericQty = Number(qty);
    
        if (numericQty < 1) {
            setqtyError(true);
        } else {
            setqtyError(false);
            setQuantity(numericQty);
            updatePriceData(numericQty, selectedTicket.rate, selectedTicket.discount_amount);
        }
    }
    const onBlurQuantity = () => {
        // Ensure that the quantity is at least 1 when the user leaves the input
        const numericQty = Number(quantity);
    
        if (quantity === '' || numericQty < 1) {
            setQuantity(1);
            setqtyError(true);
            updatePriceData(1, selectedTicket.rate, selectedTicket.discount_amount);
        }
    }
    
    const updatePriceData = (qty, rate, discount_amount) => {
        let discountedPrice = qty * (rate - discount_amount)
        discountedPrice = discountedPrice.toFixed(2)
        let price = qty * rate
        price = price.toFixed(2)
        let discount_amt = qty * discount_amount
        discount_amt = discount_amt.toFixed(2)
        let vat = 0.13 * discountedPrice
        vat = vat.toFixed(2)
        discountedPrice = parseFloat(discountedPrice) + parseFloat(vat)
        discountedPrice = Math.round(discountedPrice)+'.00'
        updateSelectedTicket({ discountedPrice: discountedPrice });
        updateSelectedTicket({ quantity: qty });
        updateSelectedTicket({ price: price });
        updateSelectedTicket({ calculated_discount: discount_amt });
        updateSelectedTicket({ vat: vat })
    }

    const updateSelectedTicket = (newKeyValue) => {
        setselectedTicket(prevState => ({
          ...prevState,  
          ...newKeyValue 
        }));
    };

    const saveTicket = () => {
        settableData(prevState => [...prevState, selectedTicket])
        // setQuantity(1)
        // setselectedTicketID(null)
        // setselectedTicket(null)
        if(tableData.length > 0) {
            let subTotal = (parseFloat(footData.subTotal) + parseFloat(selectedTicket.price)).toFixed(2)
            let discount = (parseFloat(footData.discount) + parseFloat(selectedTicket.calculated_discount)).toFixed(2)
            let taxable = parseFloat(subTotal - discount)
            let vat = parseFloat(0.13 * parseFloat(taxable))
            vat = vat.toFixed(2)
            let total = parseFloat(taxable) + parseFloat(vat)
            setfootData({
                subTotal: subTotal,
                discount: discount, 
                taxable: taxable.toFixed(2), 
                vat: vat, 
                total: Math.round(total)+'.00'
            })
        }else {
            let subTotal = (parseFloat(selectedTicket.price)).toFixed(2)
            let discount = (parseFloat(selectedTicket.calculated_discount)).toFixed(2)
            let taxable = parseFloat(subTotal - discount)
            let vat = parseFloat(0.13 * parseFloat(taxable))
            vat = vat.toFixed(2)
            let total = parseFloat(taxable) + parseFloat(vat)
            setfootData({
                subTotal: subTotal,
                discount: discount, 
                taxable: taxable.toFixed(2), 
                vat: vat, 
                total: Math.round(total)+'.00'
            })
        }
        setShowModal(false)
    }

    const handleCaptcha = (value) => {
        setCaptcha(true);
    };

    const onSubmit = async (data) => {
        setIsLoading(true)
        let ticketIDQTy = tableData.map(elem => (
            {
                id: elem.id,
                qty: elem.quantity
            }
        ))
        const postData = {
            ...data,
            date: moment(new Date()).format('YYYY/MM/DD'),
            customer_ticket_price_id: ticketIDQTy
        }
        const res = await Api.postTicketBook(postData)
        if(res.status) {
            console.log('form success',res.data.customer_id)
            return navigate("/confirm/"+res.data.customer_id);
        }else {
            setIsLoading(false)
            console.log('form error',res.data)
            toast.error('Failed to add ticket.');
        }
    }

    const removeTicket = async () => {
        // let filterData = tableData.filter(elem => elem.id === clickedID)
        let filterData = [tableData[deleteIndex]]
        filterData = filterData[0]
        // let remainingData = tableData.filter(elem => elem.id !== clickedID)
        let remainingData = tableData.filter((_, index) => index !== deleteIndex);
        settableData(remainingData)
        let subTotal = (parseFloat(footData.subTotal) - parseFloat(filterData.price)).toFixed(2)
        let discount = (parseFloat(footData.discount) - parseFloat(filterData.calculated_discount)).toFixed(2)
        let taxable = parseFloat(subTotal - discount)
        let vat = parseFloat(0.13 * parseFloat(taxable))
        vat = vat.toFixed(2)
        let total = parseFloat(taxable) + parseFloat(vat)
        setfootData({
            subTotal: subTotal,
            discount: discount, 
            taxable: taxable.toFixed(2), 
            vat: vat, 
            total: Math.round(total)+'.00'
        })
        setclickedID(null)
        setRemoveModal(false)
        toast.success('Ticket removed successfully')
    }
return(
<div>
    {isPageLoading ? (
    <div className='my-spinner-w'>
        <div className="spinner-grow" style={{'width': '3rem','height': '3rem'}}>
        </div>
        <div className='ms-3 mt-3'>Loading...</div>
    </div>) 
    : (<>
    {/* <Header breadcrumb={choseTicket ? "Customer Details" : "Choose a Ticket"} /> */}
    <Header indicator={step} />
    <div className="sm-section-container">
        <div className="container">
            {/* <h1 className='main-title display-6 text-uppercase pt-4'>Book a Ticket</h1> */}
            <div className="row desktop-book pb-4 flex-md-row flex-column-reverse">
                <div className="col-md-8">
                    {/* <div className="border-rt-dot pe-3 mt-3"> */}
                        <form onSubmit={handleSubmit(onSubmit)}>
                        {!choseTicket &&
                        <>
                        {/* <div id="formindicator">
                        <div class="form-header d-flex my-2">
                            <span class="stepIndicator active">Choose Ticket</span>
                            <span class="stepIndicator">Customer Details</span>
                            <span class="stepIndicator">Confirmation</span>
                        </div>
                        </div> */}
                        <div className="row mt-3">
                            <div className="col-lg-9">
                                <h5 className="main-title2 display-6 text-uppercase text-center text-md-start">Ticket Booking</h5>
                                <div className='d-md-none d-block my-4'>
                                    <Infobox step={step} paymentMethod={paymentMethod} />
                                </div>
                                {show && <>
                                    {tableData.length == 0 &&
                                        <small>You have not added any ticket. Please click on 'Add Ticket' button to book a ticket</small>
                                    }
                                </>}
                            </div>
                            <div className="col-lg-3 text-end my-xl-0 my-2">
                                <button type="button" 
                                    title="Add Ticket"
                                    className="btn btn-primary btn-sm_ my-sm-0 my-2" 
                                    disabled={show ? false : true}
                                    onClick={()=>{
                                        setShowModal(true)
                                        setShowClose(true)
                                        }}>
                                    + Add Ticket
                                </button>
                            </div>  
                        </div>
                        {tableData.length > 0 && 
                        <>
                        <div className='max-height-table overflow-auto'>
                            <div className='table-responsive'>
                                <table className="table table-striped mt-2 table-transp">
                                    <thead className='table-head'>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Particulars</th>
                                            <th scope="col">Rate (NPR)</th>
                                            <th scope="col-span-1">Quantity</th>
                                            <th scope="col">Price (NPR)</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody id="table-value">
                                        {tableData.map((elem,index) => (
                                        <tr key={index}>
                                            <td>{index +1}</td>
                                            <td>{elem.name}</td>
                                            <td>{elem.rate}</td>
                                            <td>{elem.quantity}</td>
                                            <td>{elem.price}</td>
                                            <td>
                                                <button className='btn btn-sm btn-danger ms-lg-2 d-inline-flex' title="Remove"
                                                    type='button'
                                                    onClick={()=>{
                                                        setclickedID(elem.id)
                                                        setRemoveModal(true)
                                                        setDeleteIndex(index)
                                                    }}>
                                                    {/* <MdDelete /> */}
                                                    <FaTrash/>
                                                </button>
                                            </td>
                                        </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan={3}></td>
                                            <td><b id="total-rate">Sub Total: </b></td>
                                            <td><b id="total-price">{footData.subTotal}</b></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3}></td>
                                            <td><b id="total-rate">Discount: </b></td>
                                            <td><b id="total-price">{footData.discount}</b></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3}></td>
                                            <td><b id="total-rate">Taxable Amount: </b></td>
                                            <td><b id="total-price">{footData.taxable}</b></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3}></td>
                                            <td><b id="total-rate">VAT 13%: </b></td>
                                            <td><b id="total-price">{footData.vat}</b></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3}></td>
                                            <td><b id="total-rate">Total: </b></td>
                                            <td><b id="total-price">NPR {footData.total}</b></td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        </>
                        }
                        </>
                        }
                        
                        {/* <div className="dotted-hr my-3"></div> */}
                        {choseTicket && 
                        <> 
                        {/* <div id="formindicator">
                        <div class="form-header d-flex mb-4 mt-2">
                            <span class="stepIndicator finish">Choose Ticket</span>
                            <span class="stepIndicator active">Customer Details</span>
                            <span class="stepIndicator">Confirmation</span>
                        </div>
                        </div> */}
                        {/* <h5 className="pb-3">Customer Details</h5> */}
                        <h5 className="main-title2 display-6 text-uppercase my-3 text-center text-md-start">Ticket Booking</h5>
                        <div className='d-md-none d-block my-4'>
                            <Infobox step={step} paymentMethod={paymentMethod} />
                        </div>
                        {/* <h5><b>Customer Details</b></h5> */}
                        <div className="row mb-xl-1">
                            <div className='col-xl-6 d-flex flex-column'>
                                <label className="col-form-label">Name<span className="text-danger">*</span></label>
                                <div className="">
                                    <input 
                                        className='form-control'
                                        {...register("name", { required: true, pattern: {
                                            value: /^[A-Za-z\s]+$/,
                                        } })} 
                                    />
                                    {/* {errors.name && <span className='text-danger'>This field is required</span>} */}
                                    {errors.name && errors.name.type === 'required' && <span className="text-danger">This field is required</span>}
                                    {errors.name && errors.name.type === 'pattern' && <span className="text-danger">Name can only contain letters and spacing</span>}
                                </div>
                            </div>
                            <div className='col-xl-6 d-flex flex-column'>
                                <label className="col-form-label">Mobile No.<span className="text-danger">*</span></label>
                                <div className="">
                                    <input 
                                        placeholder="e.g 9876543210"
                                        className='form-control'
                                        {...register('phone', { required: true, pattern: /^\+?(?:[0-9] ?){6,14}[0-9]$/ })}
                                    />
                                    <small>(Please note that ticket confirmation SMS will be sent to your provided mobile number)</small>
                                    <br/>
                                    {errors.phone && errors.phone.type === 'required' && <span className="text-danger">This field is required</span>}
                                    {errors.phone && errors.phone.type === 'pattern' && <span className="text-danger">Mobile No. is invalid</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row mb-xl-1">
                            {/* <div className='col-xl-6 d-flex flex-column'>
                                <label className="col-form-label">Email<span className="text-danger"></span></label>
                                <div className="">
                                    <input 
                                        className='form-control'
                                        {...register('email', { required: false, pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/ })}
                                    />
                                    {errors.email && errors.email.type === 'required' && <span className="text-danger">This field is required</span>}
                                    {errors.email && errors.email.type === 'pattern' && <span className="text-danger">Email is invalid</span>}
                                </div>
                            </div> */}
                            <div className='col-xl-6 d-flex flex-column'>
                                <label className="col-form-label">Address</label>
                                <div className="">
                                    <input 
                                        className='form-control'
                                        {...register("address", { required: false, pattern:{ value: /^(?!.*\.\w{2,4}$)[A-Za-z0-9\s,.'-]+$/, }}
                                        )} 
                                    />
                                    {errors.address && errors.address.type === 'required' && <span className="text-danger">This field is required</span>}
                                    {errors.address && errors.address.type === 'pattern' && <span className="text-danger">Enter valid address</span>}  
                                </div>
                            </div>
                            <div className='col-xl-6 d-flex flex-column'>
                                <label className="whitespace-nowrap col-form-label">Customer PAN</label>
                                <div className="">
                                    <input 
                                        className='form-control'
                                        placeholder="e.g 123456789"
                                        {...register("customer_pan", { required: false, pattern: /^[0-9]{9}$/ })} 
                                    />
                                    {errors.customer_pan && errors.customer_pan.type === 'pattern' && <span className="text-danger">Customer Pan is invalid</span>}
                                    <small>(For non individuals)</small>
                                </div>
                            </div>
                        </div>
                        {/* <div className="row mb-3">
                            <div className='col-xl-6 d-flex flex-column'>
                                <label className="whitespace-nowrap col-form-label">Customer PAN</label>
                                <div className="">
                                    <input 
                                        className='form-control'
                                        placeholder="e.g 123456789"
                                        {...register("customer_pan", { required: false, pattern: /^[0-9]{9}$/ })} 
                                    />
                                    {errors.customer_pan && errors.customer_pan.type === 'pattern' && <span className="text-danger">Customer Pan is invalid</span>}
                                    <small>(For non individuals)</small>
                                </div>
                            </div>
                        </div> */}
                        <div className="form-group mt-2 text-md-end text-center ">
                            {isLoading ? (
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            ) : (
                                <>
                                    <div 
                                        // className="btn btn-success my-btn-success"
                                        className='btn btn-primary me-3'
                                        onClick={()=> {
                                            setChoseTicket(false)
                                            setStep(1)
                                            window.scrollTo(0, 0)
                                            setCaptcha(false)
                                        }}
                                        title="Back">
                                        Back
                                    </div>
                                    <button 
                                        type="submit" 
                                        // className="btn btn-success my-btn-success"
                                        onClick={()=>{
                                            // setStep(3)
                                        }}
                                        className='btn btn-primary'
                                        disabled={!captcha}
                                        title="Submit">
                                        Submit
                                    </button>
                                </>
                            )}
                        </div>
                        </>
                        }
                        
                        {!choseTicket  &&
                        <>
                        {show ? 
                        <>
                            <div className='d-flex align-items-center justify-content-between flex-lg-row flex-column'>
                                <div className='d-flex align-items-center align-items-lg-start flex-column'>
                                    <h6 className='text-start'><b>Available Payment Options</b></h6>
                                    <div className="aval-pay-w justify-content-lg-start justify-content-center mb-lg-0 mb-3">
                                        {paymentMethod.map((elem,index)=>(
                                            <img key={index} src={elem.imgUrl} alt={elem.name} className='img-fluid m-1 payment-image'/>
                                        ))}
                                    </div>
                                </div>
                                <div className="form-group text-end d-flex flex-column align-items-end  justify-content-end">
                                    <div className="text-end d-flex my-0">
                                        <ReCAPTCHA
                                            sitekey="6LcyKfYUAAAAALFU9RaV2NKNDaMHprtiG5iEu-ID"
                                            onChange={()=>setCaptcha(true)}
                                            className="captcha-w_"
                                            size="normal"
                                        />
                                        <span id="error_captcha"></span>
                                    </div>
                                    <div className='d-flex flex-column justify-content-center align-items-center align-items-lg-end text-center mt-2 w-100'>
                                        <h5 className='mb-0 me-2'> 
                                        {footData.total && 
                                            <>
                                                <b>Total:</b> NPR {footData.total}
                                            </>
                                        }
                                        </h5>
                                        <button 
                                            type="button" 
                                            // className="btn btn-success my-btn-success"
                                            className='btn btn-primary mt-2'
                                            disabled={(captcha && tableData.length !== 0) ? false : true}
                                            onClick={()=> {
                                                setChoseTicket(true)
                                                window.scrollTo(0, 0)
                                                setStep(2)
                                            }}
                                            title="Submit">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </> : 
                        <>
                            <div className="py-3 notice d-flex align-items-center my-3"> 
                                <div className='info2 mx-2'>
                                    <img src={Images.info} className='info-img' />
                                </div>
                                <div className='pe-2'> 
                                    <div dangerouslySetInnerHTML={{__html: notice}} />
                                </div>
                            </div>
                        </>}
                        </>
                        }
                        </form>
                    {/* </div> */}
                </div>
                <div className="d-md-block d-none col-md-3 my-2 mt-md-0 ms-md-5 ms-0">
                    <Infobox step={step} paymentMethod={paymentMethod} />
                </div>
            </div>
        </div>
    </div>

    <div className={showModal ? 'modal my-modal fade show' : 'modal my-modal fade'} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
                <div className="modal-header flex-md-row flex-column-reverse">
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                        <Link className="navbar-brand mb-2 d-md-none" title="Siddhartha Cable Car" to='https://www.siddharthacablecar.com.np/'>
                            <img src={Images.logo} alt="Siddhartha Cable Car" className="h-logo" />
                        </Link>
                        <h5 className="modal-title text-md-start text-center">Please provide the necessary ticket information</h5>
                    </div>
                    {showClose && 
                        <button type="button" className="btn-close" 
                        onClick={()=>setShowModal(false)}
                        aria-label="Close"></button>
                    }
                </div>
                <div className="modal-body">
                    <div className="row my-3">
                        <label className="col-md-3 col-form-label">Ticket Type</label>
                        <div className="col-md-9">
                            <Select
                                options={tickets}
                                value={tickets.filter((option) => option.id === selectedTicketID)}
                                onChange={(e) => {
                                    setselectedTicketID(e.value)
                                    onChangeTicket(e.value)
                                }}
                            />
                        </div>
                        <span className="error-text name_error"></span>
                    </div>
                    <div className="row mb-3">
                        <label
                            className="col-md-3 col-form-label">Quantity</label>
                        <div className="col-md-3">
                            {/* <input type="number" min="1" className="form-control inputs"
                                value={quantity}
                                disabled={selectedTicket === null}
                                onChange={(e)=> onChangeQantity(e.target.value)}
                                /> */}
                                <input
                                    type="number"
                                    min="1"
                                    className="form-control inputs"
                                    value={quantity}
                                    disabled={selectedTicket === null}
                                    onChange={(e) => onChangeQuantity(e.target.value)}
                                    onBlur={onBlurQuantity}
                                />
                            {qtyError && <span className="text-danger">Minimum quantity should be 1</span>}
                        </div>
                    </div>
                    {selectedTicket !== null && 
                        <>
                        <div className="row mb-3">
                            <div className='col-md-12 col-6 d-md-flex mb-md-3'>
                                <label
                                    className="col-md-3 col-form-label pe-md-2">Rate</label>
                                <div className="col-md-9">
                                    <label className='col-form-label px-md-1'>NPR {selectedTicket.rate}</label>
                                </div>
                            </div>
                            <div className='col-md-12 col-6 d-md-flex'>
                                <label
                                    className="col-md-3 col-form-label pe-md-2">Discount</label>
                                <div className="col-md-9">
                                    <label className='col-form-label px-md-1'>NPR {selectedTicket.calculated_discount}</label>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className='col-md-12 col-6 d-md-flex mb-md-3'>
                                <label
                                    className="col-md-3 col-form-label pe-md-2">VAT 13%</label>
                                <div className="col-md-9">
                                    <label className='col-form-label px-md-1'>NPR {selectedTicket.vat}</label>
                                </div>
                            </div>
                            <div className='col-md-12 col-6 d-md-flex'>
                                <label
                                    className="col-md-3 col-form-label pe-md-2">Price</label>
                                <div className="col-md-9">
                                    <h4 className='fw-bold px-md-1 mt-1'>NPR {selectedTicket.discountedPrice}</h4>
                                </div>
                            </div>
                        </div>
                        </>
                    }
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-primary "
                        onClick={() => saveTicket()}
                        title='Add Ticket'
                    >Add</button>
                </div>
            </div>
        </div>
    </div>

    <div className={removeModal ? 'modal my-modal fade show' : 'modal my-modal fade'} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Ticket Remove Confirmation</h5>
                    <button type="button" className="btn-close" 
                        onClick={()=>setRemoveModal(false)}
                        aria-label="Close"></button>
                </div>
                
                <div className="modal-body">
                    <h6>Are you sure you want to remove the ticket?
                    </h6>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-primary"
                        onClick={() => setRemoveModal(false)}
                        title='Yes'
                    >No
                    </button>
                    <button type="button" className="btn btn-danger"
                        onClick={() => removeTicket()}
                        title='Yes'
                    >Yes
                    </button>
                </div>
            </div>
        </div>
    </div>
    <Footer />
    </>)}
</div>
)
}

export default Book
